import { Badge, Modal, Popconfirm, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance/AxiosInstance";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import { useMessage } from "../../MessageProvider/MessageProvider";

export default function Karzinka({ open, setOpen }) {
  let [data, setData] = useState(null);
  const { id } = useParams();
  const messageApi = useMessage();
  let gatStoredData = async () => {
    try {
      let { data } = await axiosInstance.get("/api/customers/deleted");
      console.log(data);
      setData(data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  let gatRecovered = async () => {
    try {
      let { data } = await axiosInstance.get("/api/customers/deleted", {
        customer_id: id,
      });
      console.log(data);
      setData(data?.data);
      messageApi.open({
        type: "success",
        content: "Klient qayta tiklandi!",
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    gatStoredData();
  }, []);
  return (
    <Modal
      // maxWidth={"900px"}
      // width={"100%"}
      // modalStyle={{
      //   top: "10px",
      //   maxWidth: "900px",
      //   width: "100%",
      //   margin: "auto", // Centers the modal
      // }}
      style={{ top: "10px", width: "100%" }}
      title="Karzinka"
      open={open}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpen(false);
      }}
      footer={[]}
    >
      <div className=" w-full max-w-[900px] ">
        {data?.map((el) => {
          return (
            <div
              key={el?.id}
              // to={"/customers/" + el?.id}
              className={
                "relative block m-auto  px-2 py-2 w-[100%]  text-stone-900 text-bold  cursor-pointer   border-b-[1px] border-b-[#bfbfbf36] hover:text-sky-400 "
              }
            >
              <div className=" before:content-[''] before:absolute before:bg-[#00fc37] before:z-0 before:bottom-0 before:left-0 before:h-[8px] before:w-[10%]">
                <div className="flex flex-row gap-1 justify-between mb-1 z-4">
                  <p
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    className="z-1 text-[18px] md:text-[14px] text-[#111827] p-0 m-0 col-span-2"
                  >
                    {el.id}- {el.name}
                  </p>
                  <p className="text-[17px] md:text-[14px] text-[#6b7280]  p-0 m-0 z-1">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
                    >
                      {moment(el.created_at).format("DD.MM.YYYY")}
                    </Tooltip>
                  </p>
                </div>
                <div className="flex flex-row gap-1 justify-between pl-1">
                  <div className="flex flex-row gap-1  items-center justify-center">
                    <h2 className="text-[14px] text-[#6b7280] p-0 m-0 z-1">
                      Tel: {el.phone}
                    </h2>
                    <p className="text-[14px] text-[#6b7280]  p-0 m-0 z-1">
                      INN: {el.INN}
                    </p>
                  </div>
                  <div className="relative z-0 flex flex-row items-center justify-center">
                    <Popconfirm
                      title="O'chirish"
                      description={`''` + " O'chirishga ishonchingiz komilmi?"}
                      onConfirm={() => {
                        gatRecovered();
                      }}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Tag className="!z-0" color="green">
                        Qayta tiklash
                      </Tag>
                    </Popconfirm>
                    <Badge key={1} color={"red"} text={""} />
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <p className="text-center text-[#bfbfbf] text-[14px] p-4">No more...</p>
      </div>
    </Modal>
  );
}
